module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/mapaKriminatlity@3x-862177fd0562a85c6eddde047324fc8b.png";